import { useState } from "react";
import { useApp } from "../context/AppContext";

// Choosing one's own password (docs/tasks/35, users). Shown instead of the admin
// while the password is a temporary one from an invitation or a reset, and in
// Settings at any time.
export function ChangePassword({ forced = false }) {
  const { api, session, setSession, signOut } = useApp();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setMsg(null);
    if (f.next !== f.again) { setMsg({ bad: true, text: "The two new passwords differ." }); return; }
    setBusy(true);
    try {
      const r = await api.changePassword(f.current, f.next);
      setSession({ ...session, user: { ...session.user, ...(r?.user || {}), must_change_password: false } });
      setF({ current: "", next: "", again: "" });
      setMsg({ text: "Your password is changed." });
    } catch (ex) { setMsg({ bad: true, text: String(ex.message || ex) }); } finally { setBusy(false); }
  };
  return (
    <form className="card max-w-md space-y-3" onSubmit={submit}>
      <h2 className="text-base font-semibold">{forced ? "Choose your own password" : "Change your password"}</h2>
      {forced && <p className="text-sm text-slate-600">You signed in with a temporary password. Choose your own before you continue.</p>}
      <label className="block text-xs">{forced ? "Temporary password" : "Current password"}
        <input className="input" type="password" required autoComplete="current-password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
      </label>
      <label className="block text-xs">New password (8+ characters)
        <input className="input" type="password" required minLength={8} autoComplete="new-password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
      </label>
      <label className="block text-xs">New password again
        <input className="input" type="password" required minLength={8} autoComplete="new-password" value={f.again} onChange={(e) => setF({ ...f, again: e.target.value })} />
      </label>
      <div className="flex items-center gap-3">
        <button className="btn btn-primary" type="submit" disabled={busy}>{busy ? "…" : "Save"}</button>
        {forced && <button className="text-xs text-slate-500 hover:underline" type="button" onClick={signOut}>sign out</button>}
      </div>
      {msg && <p className={`text-sm ${msg.bad ? "text-rose-700" : "text-emerald-700"}`}>{msg.text}</p>}
    </form>
  );
}
